<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a><strong><span class="orange">For Olivia and Sophia:</span></strong> You are both my sweet inspiration; every day with the two of you is filled with buttercream and chocolate sprinkles and joy.</p>
<p class="dedication"><strong><span class="orange">For Jim:</span></strong> You make me laugh just as hard today as you did the day I met you— thank you for showing me that with a sense of humor, even life’s little catastrophes can be crafted into a delicious story.</p>
<p class="dedication"><strong><span class="orange">And in memory of my father,</span></strong> who taught me that the sweetest recipe for a life well-lived starts with love.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?4602a976